import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=6b697c14&scoped=true"
import script from "./CustomerModal.vue?vue&type=script&lang=js"
export * from "./CustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b697c14",
  null
  
)

export default component.exports